import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@insio/ui-toolkit';
import { navigation } from '@/navigation';

interface PoliciesConsentCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  testId?: string;
}

/** Terms of Service + Privacy Policy consent checkbox, shared by the sign-up form and consent modal. */
export function PoliciesConsentCheckbox({
  checked,
  onChange,
  testId = 'policies-consent'
}: PoliciesConsentCheckboxProps) {
  const { t } = useTranslation();

  return (
    <div className='flex flex-row items-center gap-sm self-start'>
      <Checkbox checked={checked} onChange={onChange} id={testId} testId={testId} />
      <span className='text-sm text-foreground-muted'>
        {t('features.auth.signUp.tosConsentPrefix')}
        <Link
          to={navigation.policies('terms')}
          target='_blank'
          rel='noopener noreferrer'
          className='text-info-text font-medium underline hover:opacity-80'
        >
          {t('features.auth.signUp.tosConsentLink')}
        </Link>
        {t('features.auth.signUp.consentSeparator')}
        <Link
          to={navigation.policies('privacy')}
          target='_blank'
          rel='noopener noreferrer'
          className='text-info-text font-medium underline hover:opacity-80'
        >
          {t('features.auth.signUp.privacyConsentLink')}
        </Link>
      </span>
    </div>
  );
}
